/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* plugins/user-flow/assets/js/user-flow.js — journey map viewer (SVG Sankey), top paths, friction. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["user-flow"] = "1.1.0"; } catch (e) {}
  var NS = "http://www.w3.org/2000/svg";
  var STATE = { tab: "map", from: null, to: null, device: "", country: "" };

  /* ---- Behavioural badges from Visitor Intelligence ------------------------------------------
     Each flow node is a page; the VI behavioural map scores every page hot / confusing / friction /
     attention / drop-off / cold. We fetch it cross-plugin (read-only) and decorate the nodes. The
     classifier is copied verbatim from the Hub map so the classes agree across surfaces; if VI is not
     enabled for the site the fetch simply fails and no badges show. */
  var BMAP = {
    hot:       { label: "Hot",            color: "#1FA463", help: TR('userfl.p.high_intent_low_friction_u2014_this_') },
    confusing: { label: TR('userfl.g.confusing'),      color: "#D97706", help: TR('userfl.f3.wanted_but_hard_u2014_real_intent_') },
    friction:  { label: TR('userfl.g.high_friction'),  color: "#E0533D", help: TR('userfl.p.frustration_runs_high_u2014_somethin') },
    attention: { label: TR('userfl.g.high_attention'), color: "#6C4BE8", help: TR('userfl.p.deeply_read_u2014_people_spend_real_') },
    dropoff:   { label: TR('userfl.g.drop_off'),       color: "#EA580C", help: TR('userfl.f3.visits_tend_to_end_here_u2014_a_hi') },
    cold:      { label: TR('userfl.g.cold'),           color: "#8798B0", help: TR('userfl.f3.little_engagement_u2014_low_intent') },
    neutral:   { label: TR('userfl.g.neutral'),        color: "#5C6E88", help: TR('userfl.f2.no_strong_signal_either_way') }
  };
  function normPath(p) { p = String(p == null ? "" : p); var i = p.indexOf("?"); if (i >= 0) p = p.slice(0, i); i = p.indexOf("#"); if (i >= 0) p = p.slice(0, i); p = p.trim(); return p === "" ? "/" : p; }
  function classifyPage(p) {
    var i = p.intent || 0, f = p.frustration || 0, a = p.attention || 0, v = p.views || 0, er = v ? (p.exits || 0) / v : 0;
    var badges = [];
    if (i >= 60) badges.push([TR('userfl.g.high_intent'), "#1FA463"]);
    if (a >= 60) badges.push([TR('userfl.g.high_attention'), "#6C4BE8"]);
    if (f >= 50) badges.push([TR('userfl.g.high_friction'), "#E0533D"]);
    if (er >= 0.45) badges.push([TR('userfl.g.drop_off'), "#EA580C"]);
    var primary;
    if (f >= 55 && a >= 40 && i >= 40) primary = "confusing";
    else if (er >= 0.5 && i < 45) primary = "dropoff";
    else if (i >= 60 && f < 45) primary = "hot";
    else if (f >= 50) primary = "friction";
    else if (a >= 60) primary = "attention";
    else if (i < 30 && a < 35) primary = "cold";
    else primary = "neutral";
    return { primary: primary, badges: badges };
  }
  var BEHAV = null, LASTMAP = null;
  function loadBehav() {
    if (!site() || !STATE.from) return;
    GS.api("/plugin/visitor-intelligence/behaviormap?site=" + encodeURIComponent(site()) + "&from=" + STATE.from + "&to=" + STATE.to)
      .then(function (r) {
        var d = r && r.data ? r.data : r; BEHAV = {};
        if (d && d.ok && d.pages) d.pages.forEach(function (p) { BEHAV[normPath(p.page)] = classifyPage(p); });
        if (LASTMAP) drawMap(LASTMAP);
      })
      .catch(function () { BEHAV = {}; });
  }

  function q(k) { return document.querySelector('[data-uf="' + k + '"]'); }
  function el(tag, attrs, txt) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (txt != null) e.textContent = txt; return e; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function site() { return (window.GS && GS.site) || ""; }
  function api(action) {
    var u = GS.apiBase ? "" : ""; // GS.api prefixes apiBase
    var qs = "?site=" + encodeURIComponent(site());
    if (STATE.from) qs += "&from=" + STATE.from; if (STATE.to) qs += "&to=" + STATE.to;
    if (STATE.device) qs += "&device=" + encodeURIComponent(STATE.device);
    if (STATE.country) qs += "&country=" + encodeURIComponent(STATE.country);
    return GS.api("/plugin/user-flow/" + action + qs);
  }

  function defaultRange() {
    var to = new Date(); var from = new Date(); from.setDate(from.getDate() - 29);
    STATE.to = to.toISOString().slice(0, 10); STATE.from = from.toISOString().slice(0, 10);
    var lbl = q("range-label"); if (lbl) lbl.textContent = STATE.from + " \u2192 " + STATE.to;
  }

  function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
  function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
  function _rpPreset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
  var _RP={label:null,preset:null};
  (function(){try{var s=JSON.parse(localStorage.getItem("gs_uf_range")||"null");if(s&&s.preset){var p=_rpPreset(+s.preset);STATE.from=p.from;STATE.to=p.to;_RP.label=p.label;_RP.preset=p.preset;}else if(s&&s.from&&s.to){STATE.from=s.from;STATE.to=s.to;_RP.label=s.from+" \u2192 "+s.to;_RP.preset=null;}}catch(e){}if(!_RP.label){var d=_rpPreset(30);STATE.from=d.from;STATE.to=d.to;_RP.label=d.label;_RP.preset="30";}})();
  function _rpInit(){
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label");if(!btn||!menu)return;
    if(lab&&_RP.label)lab.textContent=_RP.label;
    function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===_RP.preset);});}
    btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=STATE.from;if(ct)ct.value=STATE.to;sync();}});
    document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
    function apply(o){STATE.from=o.from;STATE.to=o.to;_RP.label=o.label;_RP.preset=o.preset;if(lab)lab.textContent=o.label;try{localStorage.setItem("gs_uf_range",JSON.stringify({from:o.from,to:o.to,preset:o.preset}));}catch(e){}menu.style.display="none";load();}
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(_rpPreset(+b.getAttribute("data-preset")));});});
    var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
  }
  /* ---------- SVG Sankey ---------- */
  function drawMap(d) {
    var host = q("map"); if (!host) return; host.innerHTML = "";
    if (!d || !d.nodes || !d.nodes.length) { host.innerHTML = '<div class="uf-empty">'+TR('userfl.f2.no_journeys_in_this_range_yet')+'</div>'; return; }
    var steps = 0; d.nodes.forEach(function (n) { steps = Math.max(steps, n.step); });
    steps += 1;
    var W = Math.max(720, steps * 220), H = 460, padX = 20, padY = 16, colGap = (W - padX * 2) / Math.max(1, steps);
    var nodeW = 150;
    // group nodes by step, compute proportional heights
    var byStep = {}; d.nodes.forEach(function (n) { (byStep[n.step] = byStep[n.step] || []).push(n); });
    var pos = {}; // id -> {x,y,h,cx}
    Object.keys(byStep).forEach(function (s) {
      var col = byStep[s]; var tot = 0; col.forEach(function (n) { tot += n.count; });
      var usable = H - padY * 2 - (col.length - 1) * 8, y = padY, x = padX + s * colGap + (colGap - nodeW) / 2;
      col.forEach(function (n) {
        var h = Math.max(20, tot ? (n.count / tot) * usable : 20);
        pos[n.id] = { x: x, y: y, h: h, w: nodeW }; n._x = x; n._y = y; n._h = h; y += h + 8;
      });
    });
    var svg = el("svg", { viewBox: "0 0 " + W + " " + H, width: "100%", height: H, class: "uf-svg" });
    // links first (under nodes)
    (d.links || []).forEach(function (l) {
      var a = pos[l.from], b = pos[l.to]; if (!a || !b) return;
      var maxC = 1; (d.links).forEach(function (x) { maxC = Math.max(maxC, x.count); });
      var w = Math.max(1.5, (l.count / maxC) * 26);
      var x1 = a.x + a.w, y1 = a.y + a.h / 2, x2 = b.x, y2 = b.y + b.h / 2, mx = (x1 + x2) / 2;
      var p = el("path", { d: "M" + x1 + "," + y1 + " C" + mx + "," + y1 + " " + mx + "," + y2 + " " + x2 + "," + y2,
        class: "uf-link", "stroke-width": w, fill: "none" });
      p.appendChild(el("title", {}, l.count + " sessions"));
      svg.appendChild(p);
    });
    // nodes
    d.nodes.forEach(function (n) {
      var g = el("g", { class: "uf-node" + (n.exit_rate >= 60 ? " uf-hot" : ""), tabindex: "0" });
      g.appendChild(el("rect", { x: n._x, y: n._y, width: nodeW, height: n._h, rx: 8, class: "uf-node-rect" }));
      var lbl = n.path.length > 20 ? n.path.slice(0, 19) + "\u2026" : n.path;
      g.appendChild(el("text", { x: n._x + 10, y: n._y + Math.min(18, n._h / 2 + 4), class: "uf-node-t" }, lbl));
      if (n._h > 28) g.appendChild(el("text", { x: n._x + 10, y: n._y + Math.min(34, n._h - 6), class: "uf-node-s" }, n.count + " \u00b7 " + n.exit_rate + "% exit"));
      var cls = BEHAV ? BEHAV[normPath(n.path)] : null;
      var titleTxt = n.path + "\n" + n.count + " sessions \u00b7 " + n.pct + "% \u00b7 " + n.exit_rate + "% exit";
      if (cls) titleTxt += "\nBehaviour: " + BMAP[cls.primary].label + (cls.badges.length ? " \u2014 " + cls.badges.map(function (b) { return b[0]; }).join(", ") : "");
      g.appendChild(el("title", {}, titleTxt));
      if (cls) g.appendChild(el("circle", { cx: n._x + nodeW - 11, cy: n._y + 11, r: 5, fill: BMAP[cls.primary].color, stroke: "#fff", "stroke-width": 1.5, class: "uf-bm-dot" }));
      svg.appendChild(g);
    });
    host.appendChild(svg);
    // behaviour legend (only when VI behavioural data is present for these pages)
    if (BEHAV) {
      var present = {}; d.nodes.forEach(function (n) { var c = BEHAV[normPath(n.path)]; if (c) present[c.primary] = 1; });
      var keys = Object.keys(BMAP).filter(function (k) { return present[k]; });
      if (keys.length) {
        var lg = document.createElement("div"); lg.className = "uf-bm-legend";
        lg.innerHTML = '<span class="uf-bm-lgl">'+TR('userfl.g.behaviour')+'</span>' +
          keys.map(function (k) { return '<span class="uf-bm-lgi" title="' + esc(BMAP[k].help) + '"><i style="background:' + BMAP[k].color + '"></i>' + esc(BMAP[k].label) + "</span>"; }).join("") +
          '<span class="uf-bm-lgn">from Visitor Intelligence</span>';
        host.appendChild(lg);
      }
    }
  }

  function drawTopPaths(d) {
    var host = q("toppaths"); if (!host) return;
    if (!d || !d.paths || !d.paths.length) { host.innerHTML = '<div class="uf-empty">'+TR('userfl.f2.no_paths_yet')+'</div>'; return; }
    host.innerHTML = d.paths.map(function (p) {
      var chips = p.steps.map(function (s, i) { return '<span class="uf-chip">' + esc(s) + '</span>' + (i < p.steps.length - 1 ? '<span class="uf-arrow">\u203a</span>' : ''); }).join("");
      return '<div class="uf-path"><div class="uf-path-steps">' + chips + '</div>' +
        '<div class="uf-path-meta"><b>' + p.sessions + '</b> sessions \u00b7 ' + p.pct + '%' +
        (p.converted ? ' \u00b7 <span class="uf-ok">' + p.conv_rate + '% conv</span>' : '') + '</div></div>';
    }).join("");
  }

  function drawFriction(d) {
    var host = q("friction"); if (!host) return;
    var rows = (d && d.friction) || [];
    if (!rows.length) { host.innerHTML = '<div class="uf-empty">'+TR('userfl.f2.no_friction_detected')+'</div>'; return; }
    function ufFricRow(f) {
        return '<tr' + (f.dead_end ? ' class="uf-dead"' : '') + '><td>' + esc(f.path) + (f.dead_end ? ' <span class="uf-tag">dead-end</span>' : '') +
          '</td><td>' + f.occurrences + '</td><td>' + f.exits + '</td><td>' + f.exit_rate + '%</td><td>' + f.loops + '</td></tr>';
    }
    host.innerHTML = '<table class="uf-table"><thead><tr><th>'+TR('userfl.g.page')+'</th><th>'+TR('userfl.g.sessions')+'</th><th>'+TR('userfl.g.exits')+'</th><th>'+TT('uf.js.exit_rate')+'</th><th>'+TR('userfl.g.loops')+'</th></tr></thead><tbody></tbody></table>';
    var uft = host.querySelector('tbody');
    if (window.GSMore) GSMore.mount({ container: uft, table: true, colspan: 5, items: rows, pageSize: 20, emptyText: TR('userfl.f2.no_friction_detected'), render: ufFricRow });
    else uft.innerHTML = rows.map(ufFricRow).join('');
  }

  function kpis(d) {
    set("k-sessions", d && d.total_sessions != null ? d.total_sessions : "\u2013");
    set("k-entry", d && d.entries && d.entries[0] ? d.entries[0].path : "\u2013");
    set("k-exit", d && d.exits && d.exits[0] ? d.exits[0].path : "\u2013");
    set("k-pattern", d && d.pattern ? (d.pattern.shape || "\u2013") : "\u2013");
  }
  function set(k, v) { var e = q(k); if (e) e.textContent = v; }

  function load() {
    if (!site()) return;
    api("map").then(function (r) { var d = r && r.data; LASTMAP = d; kpis(d); drawMap(d); });
    loadBehav();
    api("toppaths").then(function (r) { drawTopPaths(r && r.data); });
    api("friction").then(function (r) { drawFriction(r && r.data); });
    if (STATE.tab === "referrers" && window.UFRP) window.UFRP.load(STATE);
  }

  function showTab(t) {
    if (window.GSLink) window.GSLink.write({ tab: t });
    STATE.tab = t;
    ["map", "toppaths", "friction", "referrers"].forEach(function (name) {
      var pane = q("pane-" + name); if (pane) pane.hidden = name !== t;
      var btn = document.querySelector('[data-uf-tab="' + name + '"]'); if (btn) btn.classList.toggle("active", name === t);
    });
    /* Referrer paths has its own numbers: the journey-map KPI row would describe something else there */
    var mk = document.querySelector(".uf-wrap > .uf-kpis"); if (mk) mk.hidden = t === "referrers";
    if (t === "referrers" && window.UFRP) window.UFRP.load(STATE);
  }

  /* ---- Single-visitor focus -----------------------------------------------------------------
     Visitor Intelligence (and any other surface) deep-links here with ?visitor_id / ?session_id
     via its "the path they took" tile. The aggregate flow can't answer "what did THIS person do",
     so when those params are present we fetch that one visitor's ordered pageview path and pin it
     above the aggregate. "All flows" clears it and strips the params so a refresh shows the map. */
  function fmtDwell(s) { s = +s || 0; if (!s) return ""; if (s < 60) return s + "s"; var m = Math.floor(s / 60), r = s % 60; return m + "m" + (r ? " " + r + "s" : ""); }
  function focusHost() {
    var h = document.querySelector('[data-uf="focus"]');
    if (!h) { var wrap = document.querySelector(".uf-wrap"); if (!wrap) return null;
      h = document.createElement("div"); h.className = "uf-focus"; h.setAttribute("data-uf", "focus"); wrap.insertBefore(h, wrap.firstChild); }
    return h;
  }
  function clearFocus() {
    var h = document.querySelector('[data-uf="focus"]'); if (h) h.parentNode.removeChild(h);
    try { var u = new URL(location.href); ["visitor", "visitor_id", "session", "session_id", "id", "page_url"].forEach(function (k) { u.searchParams.delete(k); });
      history.replaceState(null, "", u.pathname + (u.search || "")); } catch (e) {}
  }
  function drawFocus(h, d, vid, sid) {
    if (!d || d.ok === false) { h.innerHTML = '<div class="uf-focus-msg uf-focus-err">Could not load this visitor\u2019s flow.</div>'; return; }
    var shortId = esc(String(vid || sid || "").slice(0, 10));
    var head = '<div class="uf-focus-head"><div class="uf-focus-title"><i class="bi bi-diagram-3"></i> Visitor flow ' +
      '<span class="uf-focus-id">' + shortId + '</span></div>' +
      '<button type="button" class="uf-focus-clear" data-uf-clear>\u2190 All flows</button></div>';
    if (!d.found || !d.sessions || !d.sessions.length) {
      h.innerHTML = head + '<div class="uf-focus-msg">'+TR('userfl.no_recorded_pageviews_for_this_visitor')+'</div>'; wireClear(h); return;
    }
    var body = d.sessions.map(function (sess) {
      var steps = sess.steps || [];
      var chips = steps.map(function (st, i) {
        var arrow = (i < steps.length - 1)
          ? '<span class="uf-focus-arrow">\u203a' + (st.dwell ? '<em>' + esc(fmtDwell(st.dwell)) + '</em>' : "") + '</span>' : "";
        return '<span class="uf-chip" title="' + esc(st.path) + '">' + esc(st.path) + '</span>' + arrow;
      }).join("");
      return '<div class="uf-focus-sess"><div class="uf-focus-meta"><b>' + esc(sess.started_at || "") + '</b>' +
        (sess.device ? ' \u00b7 ' + esc(sess.device) : "") + ' \u00b7 ' + (sess.pages || steps.length) + ' pages</div>' +
        '<div class="uf-focus-path">' + chips + '</div></div>';
    }).join("");
    var summ = '<div class="uf-focus-sum">' + d.session_count + ' session' + (d.session_count === 1 ? "" : "s") +
      ' \u00b7 ' + d.step_count + ' pageviews</div>';
    h.innerHTML = head + summ + body; wireClear(h);
  }
  function wireClear(h) { var b = h.querySelector("[data-uf-clear]"); if (b) b.addEventListener("click", clearFocus); }
  function loadVisitorFocus(vid, sid) {
    var h = focusHost(); if (!h) return;
    h.innerHTML = '<div class="uf-focus-msg">Loading visitor flow\u2026</div>';
    var qs = "?site=" + encodeURIComponent(site());
    if (vid) qs += "&visitor=" + encodeURIComponent(vid);
    if (sid) qs += "&session=" + encodeURIComponent(sid);
    GS.api("/plugin/user-flow/visitor" + qs)
      .then(function (r) { drawFocus(h, r && r.data ? r.data : r, vid, sid); })
      .catch(function () { h.innerHTML = '<div class="uf-focus-msg uf-focus-err">Could not load this visitor\u2019s flow.</div>'; });
  }
  function focusParams() {
    try { var p = new URLSearchParams(location.search);
      return { vid: p.get("visitor") || p.get("visitor_id") || "", sid: p.get("session") || p.get("session_id") || "" }; }
    catch (e) { return { vid: "", sid: "" }; }
  }

  /* init() is reached twice when GS.site is already set as this file runs AND gs:ready fires afterwards
     (both hooks are below). Twice meant two click handlers on the date pill, which opened and at once
     closed the menu again, plus every report loaded twice. Run it once. */
  var _inited = false;
  function init() {
    if (_inited) return; _inited = true;
    defaultRange(); _rpInit();
    document.addEventListener("click", function (e) {
      var tb = e.target.closest ? e.target.closest("[data-uf-tab]") : null;
      if (tb) { showTab(tb.getAttribute("data-uf-tab")); return; }
      /* preset handling moved to _rpInit picker */
    });
    var dev = q("device"); if (dev) dev.addEventListener("change", function () { STATE.device = dev.value; load(); });
    (function () {
      /* Deep link: /user-flow?device=<desktop|mobile|tablet>&country=<CC> — the VI Segment view
         sends these so the flow opens scoped to that segment. The backend already filters on both;
         we just pre-set the state (and reflect device in the picker) before the first load. */
      try {
        var p = new URLSearchParams(location.search);
        var dv = (p.get("device") || "").toLowerCase().replace(/[^a-z]/g, "");
        var cc = (p.get("country") || "").toUpperCase().replace(/[^A-Z]/g, "").slice(0, 2);
        if (dv) { STATE.device = dv; var ds = q("device"); if (ds) ds.value = dv; }
        if (cc) STATE.country = cc;
      } catch (e) {}
    })();
    (function () {
      /* Deep link: /user-flow?tab=map|toppaths|friction. Falls back to the default tab when the
         value is not one of the three that exist — an unknown tab must not blank the page. */
      var t = null;
      if (window.GSLink) t = window.GSLink.read({ tab: "slug" }).tab;
      else { try { t = (String(new URLSearchParams(location.search).get("tab") || "").toLowerCase().replace(/[^a-z0-9-]/g, "")) || null; } catch (e) { t = null; } }
      showTab(["map", "toppaths", "friction", "referrers"].indexOf(t) >= 0 ? t : "map");
    })(); load();
    var fp = focusParams(); if (fp.vid || fp.sid) loadVisitorFocus(fp.vid, fp.sid);
  }
  document.addEventListener("gs:ready", init);
  document.addEventListener("gs:site-change", function () { BEHAV = null; LASTMAP = null; load(); });
  if (window.GS && GS.site) init();
})();

/* ---- settings (max steps, conversion goal, collapse repeats) ---- */
(function () {
  function q(k) { return document.querySelector('[data-uf="' + k + '"]'); }
  function loadSettings() {
    if (!(window.GS && GS.site)) return;
    GS.api("/plugin/user-flow/settings?site=" + encodeURIComponent(GS.site)).then(function (r) {
      var s = (r && r.data && r.data.settings) || {}; 
      if (q("set-steps")) q("set-steps").value = s.max_steps || 6;
      if (q("set-goal")) q("set-goal").value = s.goal || "";
      if (q("set-collapse")) q("set-collapse").checked = s.collapse_repeats !== false;
    });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest('[data-uf="save-settings"]') : null; if (!b) return;
    e.preventDefault();
    var body = { max_steps: +((q("set-steps") || {}).value || 6), goal: (q("set-goal") || {}).value || "", collapse_repeats: !!((q("set-collapse") || {}).checked) };
    GS.api("/plugin/user-flow/save-settings?site=" + encodeURIComponent(GS.site), { method: "POST", body: JSON.stringify(body) }).then(function (r) {
      var n = q("set-note"); if (n) { n.hidden = false; n.textContent = (r && r.ok && r.data && r.data.ok) ? "Saved." : TR('userfl.g.save_failed'); setTimeout(function () { n.hidden = true; }, 1500); }
    });
  });
  document.addEventListener("gs:ready", loadSettings);
})();
